module.exports = __webpack_public_path__ + "img/1725585606786-WhatsApp Image 2024-09-06 at 09.12.00.jpeg.537805bb.webp";